var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M42.4 956c-16.1 0-30.1-12-32.2-28.5-.3-2.2-6.6-55.3 9.9-127.4 9.7-42.1 25.2-82.4 46.2-119.7 26.2-46.6 60.9-88.6 103.2-124.9 42.6-36.5 91-64.2 143.9-82.4 42.1-14.5 87.1-22.9 133.7-25.1 73.2-3.4 127.3 9.7 137.2 12.3 8.3 1.6 45.7 9.8 93.2 33.2 16.1 7.9 22.7 27.4 14.8 43.5-7.9 16.1-27.4 22.7-43.5 14.8-43.3-21.3-76.1-27.6-77.5-27.9-1.1-.2-2.1-.4-3.2-.7-.4-.1-50.9-13.8-120.3-10.2-91.2 4.7-170.6 35.6-236.1 91.7C54.2 740.2 74.4 917.6 74.7 919.4c2.2 17.8-10.4 34.1-28.2 36.3-1.4.2-2.8.3-4.1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222650",
    d: "M792.9 629.1c43.5 0 84.4 16.9 115.1 47.7 30.7 30.7 47.7 71.6 47.7 115.1S938.8 876.3 908 907c-30.7 30.7-71.6 47.7-115.1 47.7s-84.4-16.9-115.1-47.7c-30.7-30.7-47.7-71.6-47.7-115.1s16.9-84.4 47.7-115.1c30.7-30.8 71.6-47.7 115.1-47.7m0-65c-125.8 0-227.8 102-227.8 227.8 0 125.8 102 227.8 227.8 227.8s227.8-102 227.8-227.8c-.1-125.9-102.1-227.8-227.8-227.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M470.7 67.9c50.3 0 97.6 19.6 133.2 55.2 35.6 35.6 55.2 82.9 55.2 133.2s-19.6 97.6-55.2 133.2c-35.6 35.6-82.9 55.2-133.2 55.2s-97.6-19.6-133.2-55.2c-35.6-35.6-55.2-82.9-55.2-133.2s19.6-97.6 55.2-133.2c35.6-35.6 82.9-55.2 133.2-55.2m0-65c-139.9 0-253.4 113.4-253.4 253.4 0 139.9 113.4 253.4 253.4 253.4s253.4-113.4 253.4-253.4S610.6 2.9 470.7 2.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#222650",
    d: "M743.5 893.1c-8.3 0-16.6-3.2-23-9.5-12.7-12.7-12.7-33.3 0-46L834.1 724c12.7-12.7 33.3-12.7 46 0 12.7 12.7 12.7 33.3 0 46L766.4 883.5c-6.3 6.4-14.6 9.6-22.9 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222650",
    d: "M857 893.1c-8.3 0-16.6-3.2-23-9.5L720.5 770c-12.7-12.7-12.7-33.3 0-46 12.7-12.7 33.3-12.7 46 0L880 837.6c12.7 12.7 12.7 33.3 0 46-6.3 6.3-14.6 9.5-23 9.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDenied);
export default ForwardRef;